import * as React from 'react';
import { Flex, Box } from '../../CommonUI/Layout';
import * as images from '../../Assets/images/svg';

export const Note: React.SFC<React.HTMLProps<HTMLParagraphElement>> = (props) => {
    const { children } = props;
    return (
            <Flex alignItems="middle" flexDirection="row">
                <Box width="auto" mr={10}>
                    <images.checked/>
                </Box>
                {children}
            </Flex>
    );
};
